(() => {
  const notice = document.querySelector('[data-cookie-notice]');
  if (!notice) return;
  const key = 'toro.cookie-preference.v1';
  let choice;
  // Storage may be denied by the browser. Dismissal still works in this document.
  try { choice = localStorage.getItem(key); } catch { /* No persistent storage available. */ }
  if (choice === 'all' || choice === 'necessary') return;
  notice.hidden = false;
  const reserveSpace = () => {
    document.body.style.paddingBottom = `${notice.offsetHeight + 24}px`;
  };
  const observer = new ResizeObserver(reserveSpace);
  observer.observe(notice);
  reserveSpace();
  notice.querySelectorAll('[data-cookie-choice]').forEach((button) => {
    button.addEventListener('click', () => {
      try { localStorage.setItem(key, button.dataset.cookieChoice); } catch { /* Keep current-document dismissal. */ }
      notice.hidden = true;
      observer.disconnect();
      document.body.style.removeProperty('padding-bottom');
      const main = document.getElementById('MainContent');
      main.setAttribute('tabindex', '-1');
      main.focus({preventScroll: true});
    });
  });
})();
